// client/src/components/anamnese/AssinarAnamneseModal.js
// Assinatura presencial de uma ficha já finalizada como 'awaiting_signature'
// (staff gerou o link mas o cliente está ali, na hora, e prefere assinar
// direto no painel em vez de usar o link remoto). Respostas já foram
// preenchidas antes — aqui só coleta a assinatura.
import React, { useRef } from 'react';
import { Save, Loader2 } from 'lucide-react';
import FormModal from '../layout/FormModal';
import AssinaturaCanvas from '../common/AssinaturaCanvas';
import { useUpdateAnamnese } from '../../hooks/useAnamneses';
import useAlert from '../../hooks/useAlert';

const AssinarAnamneseModal = ({ anamnese, onClose }) => {
    const { setAlert } = useAlert();
    const updateAnamnese = useUpdateAnamnese();
    const canvasRef = useRef(null);

    const handleSubmit = (e) => {
        e.preventDefault();
        const assinatura = canvasRef.current?.getSignature();
        if (!assinatura) {
            setAlert('Colete a assinatura no campo indicado antes de confirmar.', 'warning');
            return;
        }
        updateAnamnese.mutate(
            { id: anamnese._id, assinaturaCliente: assinatura },
            { onSuccess: onClose }
        );
    };

    return (
        <FormModal title={`Assinar Ficha — ${anamnese.templateNome || 'Anamnese'}`} onClose={onClose}>
            <form onSubmit={handleSubmit}>
                <div className="form-group full-width">
                    <label className="form-label">Assinatura*</label>
                    <AssinaturaCanvas ref={canvasRef} />
                </div>
                <div className="form-actions">
                    <button type="button" onClick={onClose} className="action-button action-button-secondary">Cancelar</button>
                    <button type="submit" disabled={updateAnamnese.isPending} className="action-button action-button-primary">
                        {updateAnamnese.isPending ? <Loader2 size={18} className="animate-spin icon" /> : <Save size={18} className="icon" />}
                        Confirmar Assinatura
                    </button>
                </div>
            </form>
        </FormModal>
    );
};

export default AssinarAnamneseModal;
